import { CompanySetupContext } from '@company/contexts/CompanySetupContext';
import { useAddCompanyImageMutation } from '@company/services/company';
import { RichTextEditor } from '@components/utility/richTexts';
import { getTextFromHTML, handleImageUpload } from '@utils/common';
import { ImageNodeAttributes, RichTextEditorProvider } from 'mui-tiptap';
import { useCallback, useContext } from 'react';

const DetailsStep = () => {
    const {
        formik: { values, touched, errors },
        editor,
    } = useContext(CompanySetupContext);
    const [addCompanyImage] = useAddCompanyImageMutation();

    const handleNewImageFiles = useCallback(
        async (files: File[], position?: number): Promise<ImageNodeAttributes[]> =>
            await handleImageUpload({
                editor,
                files,
                position,
                postCall: addCompanyImage,
            }),
        [addCompanyImage, editor]
    );

    return (
        <RichTextEditorProvider editor={editor}>
            <RichTextEditor
                label="Description"
                InputLabelProps={{
                    error: touched.description && Boolean(errors.description),
                }}
                error={touched.description && Boolean(errors.description)}
                helperText={touched.description && errors.description ? errors.description : ''}
                hasValue={!!getTextFromHTML(values.description ?? '')}
                handleNewImageFiles={handleNewImageFiles}
                richTextContentProps={{
                    classes: {
                        root: 'h-full',
                    },
                }}
                menuBarProps={{
                    classes: {
                        root: '!-top-[24px]',
                    },
                }}
            />
        </RichTextEditorProvider>
    );
};

export { DetailsStep };
